import { useMutation } from '@apollo/client/react'
import { Button, Popconfirm, useMessage } from '@faceup/ui-base'
import { graphql } from '../__generated__'

type RemoveSsoButtonProps = {
  motherId: string
}

const mutations = {
  forceDeleteCompanyOpenId: graphql(`
    mutation ForceDeleteCompanyOpenIdMutation($input: ForceDeleteCompanyOpenIdInput!) {
      forceDeleteCompanyOpenId(input: $input) {
        company {
          id
          openIdProviderUrl
        }
      }
    }
  `),
}

export const RemoveSsoButton = ({ motherId }: RemoveSsoButtonProps) => {
  const message = useMessage()

  const [forceDeleteCompanyOpenId, { loading }] = useMutation(mutations.forceDeleteCompanyOpenId, {
    onError: () => {
      message.error('Failed to remove SSO')
    },
    onCompleted: () => {
      message.success('SSO removed. Members were emailed a link to set a password.')
    },
  })

  return (
    <Popconfirm
      title='Remove the SSO (OpenID) configuration?'
      description='This deletes the identity provider and migrates every member off SSO. They will be emailed a link to set a password. This cannot be undone.'
      okText='Remove SSO'
      okButtonProps={{ danger: true }}
      onConfirm={() =>
        forceDeleteCompanyOpenId({
          variables: {
            input: {
              motherId,
            },
          },
        })
      }
    >
      <Button danger loading={loading}>
        Remove SSO
      </Button>
    </Popconfirm>
  )
}
